import React, { useState } from 'react';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import { useTranslation } from '@lt/localization';

import { DEMO_COOKIE } from './constants';

export const LayersControlDemo = (): JSX.Element | null => {
  const [active, setActive] = useState(true);

  const { t } = useTranslation();

  const handleClose = () => {
    const { name, expires } = DEMO_COOKIE;

    const cookieValue = 'hide';
    Cookies.set(name, cookieValue, { expires });

    setActive(false);
  };

  if (!active || Cookies.get(DEMO_COOKIE.name)) return null;

  return (
    <Container>
      <Title>{t('map.controls.demo.interesting')}</Title>
      <div>{t('map.controls.demo.text')}</div>

      <CloseButton onClick={handleClose} aria-label="Закрыть" />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 66px;
  padding: 10px 15px;
  min-width: 230px;
  width: 100%;
  font-size: 15px;
  line-height: normal;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.2);
`;

const Title = styled.h3`
  font-size: 17px;
`;

const CloseButton = styled.button`
  position: absolute;
  z-index: 10;
  top: 10px;
  right: 10px;
  overflow: hidden;
  width: 25px;
  height: 25px;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;

  ::before,
  ::after {
    position: absolute;
    top: 50%;
    left: 18%;
    margin-top: -1px;
    width: 66%;
    height: 1px;
    opacity: 0.66;
    content: '';
    background: #000;
  }

  ::before {
    transform: rotate(45deg);
  }

  ::after {
    transform: rotate(-45deg);
  }
`;
